import s from '../style.module.scss';
import { useJoin } from '@/libTTS/useCommon';
import PhoneOutlined from '@/assets/img/icon@2x.webp';
import Config from '@/configTTS';
import aigcConfig from '@/configTTS';
import { agentSessionUpsertTTS, checkBusiness } from '@/api/grt/ai';
import { getUserId } from '@/utils/Page';
import ToastUtils from '@/utils/ToastUtils';
import { getSkillPluginNames } from '@/utils/Page';
import { pluginMap } from '@/utils/Page/constant';
import { Display } from '@/components/Display/Display';
import { inject, observer } from 'mobx-react';
const ChatTTS = (props) => {
    const { grtAi, skillStore, simulation, chatStore, sessionStore, preQuestionStore } = props.store;
    let {
        checkIsLogin,

        currentSessionMapId: currentSessionMapIdRef,
        formatSessionList,
        linkToSession
    } = chatStore;
    let {
        sessionMap,
        originSessionList: sessionListRef,
        changeOriginMsgMap: changeOriginMsgMapRef,
        originMsgMap,
        sessionList,
        changeCurrentSessionMapId
    } = sessionStore;
    let { isFileChatType, curPlugin, setCurPlugin, curSkill, setCurSkill, skillList, getGroupSkillList, skillPreQuestion } = skillStore;
    let skillId = curSkill?.ability_id || '';
    const { agentId, isNewSessionRef, onInputVisibilityChange, onShowTTSComponent, onTTSToggle, hideTTSActions, setHideTTSActions } = props;
    const [joining, dispatchJoin] = useJoin();
    const username = aigcConfig.BaseConfig.UserId;
    const roomId = aigcConfig.BaseConfig.RoomId;
    const checkCanUse = async () => {
        let res = await checkBusiness({ agent_id: agentId });
        if (!res || !res.success || !res.data) {
            ToastUtils.showToast('该智能体未对外开放，请联系管理员' || []);
            return false;
        }
        return true;
    };
    const onClickTTS = async () => {
        let isLogin = await checkIsLogin();
        if (!isLogin) {
            checkIsLogin(true);
            return false;
        }
        let isCanUse = await checkCanUse();
        if (!isCanUse) {
            return false;
        }
        // 检查是否正在生成结果
        if (sessionMap[currentSessionMapIdRef] && sessionMap[currentSessionMapIdRef]?.loading) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            return false;
        }
        if (!joining) {
            dispatchJoin(
                {
                    username,
                    roomId,
                    publishAudio: true
                },
                false
            );
        }

        if (!currentSessionMapIdRef) {
            agentSessionUpsertTTS({
                user_id: getUserId(),
                agent_id: agentId,
                skill_id: curSkill?.ability_id,
                question: '新问答对话'
            }).then((res) => {
                if (!currentSessionMapIdRef) {
                    const skillIdData = skillId || '';
                    const newSessionId = res.data;
                    changeCurrentSessionMapId(newSessionId);

                    linkToSession(newSessionId, { replace: true });
                    let curList = sessionListRef ? sessionListRef : [];
                    let data = [{ session_name: '新问答对话', time_range: '1', session_id: newSessionId, skill_id: skillIdData }, ...curList];
                    console.log('setSessionList', data);
                    formatSessionList(data);
                    // isNewSessionRef.current = true;
                }
                console.log('agentSessionUpsertTTS', res.data);
            });
        }
        Config.WelcomeSpeech = 'Hi，你已开启语音通话，你可以随时向我提问哦';
        Config.TTSMode = true;
        if (onTTSToggle) {
            onTTSToggle();
        }
        onInputVisibilityChange && onInputVisibilityChange(false);
        onShowTTSComponent && onShowTTSComponent(true);
    };
    return (
        <Display show={curSkill?.plugin_json?.length > 0 && getSkillPluginNames(curSkill?.plugin_json).includes(pluginMap.voice_call)}>
            <div className={s['chat-tts']}>
                <img
                    src={PhoneOutlined}
                    alt=""
                    onClick={() => {
                        onClickTTS();
                        if (setHideTTSActions) {
                            setHideTTSActions(false);
                            console.log('hideTTSActions', hideTTSActions);
                        }
                    }}
                />
            </div>
        </Display>
    );
};

export default inject('store')(observer(ChatTTS));
